import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Layout from "../Layout";
import { searchText } from "../../actions";
import { RiPlayMiniFill } from "react-icons/ri";
import { songs } from "../../database/song";
import SongCard from "../SongCard";

function Search(props) {
  let songToSearch = props.song;

  const playPause = useRef();

  const [songsData, setSongsData] = useState([]);

  const showPlayPause = () => {
    playPause.current.style.opacity = 1;
    playPause.current.style.transform = "translateY(-36px)";
  };
  const unShowPlayPause = () => {
    playPause.current.style.opacity = 0;
    playPause.current.style.transform = "translateY(0px)";
  };

  useEffect(() => {
    getSearchedDataFromDB(songToSearch);
  }, [songToSearch]);

  const getSearchedDataFromDB = async (songToSearch) => {
    if (songToSearch) {
      let songToArray = [];
      songs.filter((song) => {
        if (
          song.title
            .toLocaleLowerCase()
            .includes(songToSearch.toLocaleLowerCase()) ||
          song.movie
            .toLocaleLowerCase()
            .includes(songToSearch.toLocaleLowerCase()) ||
          song.year
            .toLocaleLowerCase()
            .includes(songToSearch.toLocaleLowerCase()) ||
          song.singer
            .toLocaleLowerCase()
            .includes(songToSearch.toLocaleLowerCase()) ||
          song.language
            .toLocaleLowerCase()
            .includes(songToSearch.toLocaleLowerCase())
        ) {
          songToArray.push(song);
        }
      });
      setSongsData(songToArray);
    }
  };

  return (
    <>
      <Layout isSearch={true} />
      <div className="pl-64 pt-20 w-screen pb-32">
        <h4 className="text-white text-xl font-semibold">Searches</h4>
        <div className="pt-4 flex">
          {songToSearch == "" ? (
            <div
              onMouseOver={showPlayPause}
              onMouseOut={unShowPlayPause}
              className="w-[580px] h-[300px] mr-4 rounded-lg relative cursor-pointer hover:opacity-100 opacity-90 transition-all ease-in"
              style={{
                backgroundImage: "linear-gradient(#aa11ea, #9198e5)",
              }}
            >
              <div className="absolute bottom-6 left-6">
                <h2 className="text-3xl font-bold text-blue-100">
                  No Search Songs
                </h2>
                <p className="text-lg  text-blue-100">0 liked songs</p>
              </div>
              <div
                ref={playPause}
                className="w-12 h-12  rounded-full  bg-[#1fdf64] hover:bg-[#63e894] opacity-0 absolute right-6 bottom-2  transition-all ease-in-out flex items-center justify-center duration-300"
              >
                <RiPlayMiniFill className="text-black text-3xl   rounded-full " />
              </div>
            </div>
          ) : (
            songsData.map((data) => {
              return <SongCard key={data._id} data={data} link="/album/" />;
            })
          )}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    song: state.searchText,
  };
};

export default connect(mapStateToProps, { searchText })(Search);
